import TextareaAutosize from "react-textarea-autosize";
import { profileData } from "../../constants/profile";
import { account_type,permission_type } from "../../constants";
import { useContext,useEffect } from "react";
import account from "../../context/generalaccount";
import Account from "../../context/acount";
export default function ProifleDetails() {
  // const divstyle="flex space-x-2";
  const {
    submitDetails,
    handleChangeDetails,
    finaldetails,
    loading
  }=useContext(account);
 const {control}=useContext(Account)
  const pstyle = "font-Roboto text-gray-600 font-medium tracking-wider text-sm";
  const inputTyle = "border-2 border-gray-500 p-1 rounded-md";
 
  if(!control)
  return 'Loading..'
  return (
    <div className="flex space-x-2">
      <div className="space-y-6">
        {profileData
          .filter((el) => {
            if (finaldetails.accountType === account_type.USER) {
              if (el.value === "password") return false;
              else return true;
            } else return true;
          }).map((el) => (
          <p className={pstyle} key={el.value}>{el.label}</p>
        ))}
      </div>
      <div className="flex flex-col space-y-1">
        {profileData
          .filter((el) => {
            if (finaldetails.accountType === account_type.USER) {
              if (el.value === "password") return false;
              else return true;
            } else return true;
          })
          .map((el) => {
            if (el.type === "textarea")
              return (
                <TextareaAutosize
                  minRows={3}
                  maxRows={6}
                  value={finaldetails[el.value] || ""}
                  key={el.value}
                  onChange={(e) =>
                    handleChangeDetails(el.value, e.target.value)
                  }
                  disabled={finaldetails.accountType===account_type.USER?!control[permission_type.EDIT_USER]:!control[permission_type.EDIT_EMPLOYEE]}
                  className="border-2 border-gray-500 rounded-md"
                />
              );
            else
              return (
                <input
                  type={el.type}
                  className={inputTyle}
                  value={finaldetails[el.value] || ""}
                  key={el.value}
                  disabled={finaldetails.accountType===account_type.USER?!control[permission_type.EDIT_USER]:!control[permission_type.EDIT_EMPLOYEE]}
                  onChange={(e) =>
                    handleChangeDetails(el.value, e.target.value)
                  }
                />
              );
          })}
        <button
          className="bg-indigo-500 shadow-lg shadow-indigo-500/50 p-1 rounded-md font-Roboto font-bold text-white"
          disabled={loading  || (finaldetails.accountType===account_type.USER?!control[permission_type.EDIT_USER]:!control[permission_type.EDIT_EMPLOYEE])}
          onClick={submitDetails}
        >
          update details
        </button>
      </div>
    </div>
  );
}
